import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { ConfirmHost } from '../ui/Confirm';
import { ToastHost, toast } from '../ui/toast';
import { Footer } from './Footer';
import { TopBar, useSession } from './TopBar';

/**
 * The community shell: sticky top bar, the page, the footer pinned to the
 * bottom, plus the toast and confirm hosts. Menus close on any click that
 * reaches the root (each menu stops propagation for its own surface).
 *
 * Whether this is a guest is the session's answer (401 → nobody), asked
 * once and cached; pages ask the same hook and agree with the bar.
 *
 * The shell fills #root (a 100%-tall flex column) and never shrinks: a
 * shrunk shell is one screen tall, so the sticky bar (whose bounds are the
 * shell) scrolled away after the first screen of a long page. Filling #root
 * rather than 100vh keeps a short page's footer above a phone's toolbar.
 */
export function CommunityLayout() {
  const [search, setSearch] = useState('');
  const { data: me, isLoading } = useSession();
  const guest = isLoading ? undefined : !me?.userId;
  useEffect(() => {
    try {
      const queued = sessionStorage.getItem('tr.toast');
      if (queued) {
        sessionStorage.removeItem('tr.toast');
        toast(queued);
      }
    } catch {
      /* storage unavailable: nothing to show */
    }
  }, []);
  return (
    <div style={{ flex: '1 0 auto', display: 'flex', flexDirection: 'column', background: '#fff' }}>
      <TopBar guest={guest} search={search} onSearch={setSearch} />
      <Outlet />
      <Footer />
      <ToastHost />
      <ConfirmHost />
    </div>
  );
}
